import { useMemo } from 'react'
import { useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'event_action',
  })

  return useMemo(() => {
    if (!data) return data

    if (data.length === 0) {
      change(next => {
        next.data.email = false
      })
    }

    return data
  }, [data])
}
